import { MessageCenterConf, MessageCenterCategory } from 'constants/constants';

export const getMsgCategory = () => {
    const env = process.env.REACT_APP_RUN_ENV;
    return MessageCenterCategory[env];
};

export const getMsgConf = () => {
    const env = process.env.REACT_APP_RUN_ENV;
    return MessageCenterConf[env];
};
